import { render, staticRenderFns } from "./gitem.vue?vue&type=template&id=21e204a0&"
import script from "./gitem.vue?vue&type=script&lang=js&"
export * from "./gitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports